import { Grid } from "@material-ui/core";
import { memo } from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { formatToValue } from "../../../../utils/formatNumber";
import { PieChartTotalTitle, PieChartTotalValue } from "../../styles/DashBoard";
import { BillsPieChartToolTip } from "../ChartToolTips";

const ERPPieChart = ({ data, closedLabel }) => {
  const hasCredit = data.some((info) => info.name === "credit" && info.value);

  const situations = {
    open: { fill: "#3366cc", label: "A Vencer" },
    closed: { fill: "#7fc8a9", label: closedLabel },
    expired: { fill: "#fa8072", label: "Vencido" },
    empty: { fill: "#f4f4f4", label: "Sem movimentação" },
  };

  if (hasCredit) situations["credit"] = { fill: "#FFD600", label: "Crédito" };

  const emptyData = { name: "empty", value: 1 };

  const isEmpty = data.every((info) => !info.value);
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    value,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    if (!value) return;

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx && percent > 0.35 ? "end" : "start"}
        dominantBaseline="central"
        fontSize="14px"
        fontFamily="Roboto, Helvetica, Arial, sans-serif"
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };

  return (
    <Grid container>
      <Grid item xs>
        <ResponsiveContainer height={350}>
          <PieChart width={600} height={300}>
            {isEmpty ? (
              <Pie
                data={[emptyData]}
                stroke="none"
                dataKey={"value"}
                fill={situations[emptyData.name].fill}
              />
            ) : (
              <Pie
                data={data}
                minAngle={5}
                dataKey={"value"}
                stroke="none"
                label={renderCustomizedLabel}
                labelLine={false}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={situations[entry.name].fill}
                  />
                ))}
              </Pie>
            )}

            <Tooltip
              content={
                <BillsPieChartToolTip
                  isEmpty={isEmpty}
                  situations={situations}
                />
              }
            />
            <Legend
              layout="horizontal"
              iconType="circle"
              verticalAlign="bottom"
              align="center"
              formatter={(value) => situations[value].label}
            />
          </PieChart>
        </ResponsiveContainer>
      </Grid>
      <Grid container item xs alignItems="center" justifyContent="center">
        {data.map((item) => (
          <Grid item container xs={6} direction="column" key={item.name}>
            <Grid item>
              <PieChartTotalTitle>
                Total {situations[item.name].label}
              </PieChartTotalTitle>
            </Grid>
            <Grid item>
              <PieChartTotalValue color={situations[item.name].fill}>
                R$ {formatToValue(item.value)}
              </PieChartTotalValue>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default memo(ERPPieChart);
